import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 0C10.866 0 14 3.13401 14 7V15H0V7C0 3.13401 3.13401 0 7 0ZM3.53513 16C4.22675 17.1956 5.51944 18 7 18C8.48057 18 9.77325 17.1956 10.4649 16H3.53513Z"
      fill="white"
    />
  </svg>
);
